import { useAppLanguage } from "hooks/useAppLanguage";

/**
 * Direction helpers for admin list/table layouts (RTL Arabic / LTR English).
 */
export function useDirection() {
  const language = useAppLanguage();
  const isArabic = language === "ar";
  const dir = isArabic ? ("rtl" as const) : ("ltr" as const);
  const textAlign = isArabic ? "text-right" : "text-left";
  const flexReverse = isArabic ? "flex-row-reverse" : "";
  const justifyStart = isArabic ? "justify-end" : "justify-start";

  return { language, isArabic, dir, textAlign, flexReverse, justifyStart };
}
